import modules from './modules'

const urls = {
    home: '/',
    login: '/login',
    userCallback: '/user/callback',
    facility: '/facility',
    facilities: '/facilities',
    bidPackage: '/bidPackage',
    bidPackages: '/bidPackages',
    bidResponse: '/bidResponse',
    bidResponses: '/bidResponses',
    invoice: '/invoice',
    invoices: '/invoices',
    projects: '/projects',
    project: '/project',
    entity: '/entity',
    entities: '/entities',
    well: '/well',
    wells: '/wells',
    bond: '/bond',
    bonds: '/bonds',
    uicPermit: '/uicPermit',
    uicPermits: '/uicPermits',
    features: [
        {
            name: 'UIC Permits',
            url: '/uicPermits',
            type: modules.editor.type,
        },
        {
            name: 'UIC Wells',
            url: '/wells',
            type: modules.editor.type,
        },
        {
            name: 'Entities',
            url: '/entities',
            type: modules.editor.type,
        },
    ],
}

const apiUrls = {
    facility: 'facility',
    facilityGroup: 'facilityGroup',
    bidPackage: 'bidPackage',
    bidResponse: 'bidResponse',
    invoice: 'invoice',
    schema: 'schema',
    lookup: 'lookup',
    autoCalc: 'autoCalculate',
    upload: 'upload',
    entity: 'entity',
    bond: 'bond',
    well: 'well',
    uicPermit: 'uicPermit',
    epa7520Reports: 'epa-7520-reports',
    mapLayer: 'MapLayer',
}

const getCreateLink = (url) => {
    return `${url}/new`
}

export { apiUrls, getCreateLink }
export default urls
